export default __webpack_public_path__ + "static/media/ARTISANSGOLD.5a6d0849.svg";